<template>
  <div>
    <validation-observer ref="refFormObserver">
      <b-form>
        <b-row>
          <b-col cols="12" lg="6">
            <form-field-select
              id="logLevel"
              v-model="itemData.config.logLevel"
              :label="$t('proxy_rtsp_server.log_level')"
              :options="logLevelOptions"
              rules="required"
              multiple
              taggable
              :push-tags="true"
              :reduce-option="(option) => option"
            />
          </b-col>
          <b-col cols="12" lg="6">
            <form-field-select
              id="logDestinations"
              v-model="itemData.config.logDestinations"
              :label="$t('proxy_rtsp_server.log_destinations')"
              :options="logDestinationsOptions"
              multiple
              taggable
              :push-tags="true"
              :reduce-option="(option) => option"
              rules="required"
            />
          </b-col>
          <b-col cols="12" lg="6">
            <form-field-text
              id="logFile"
              v-model="itemData.config.logFile"
              :label="$t('proxy_rtsp_server.log_file')"
            />
          </b-col>
          <b-col cols="12" lg="6">
            <form-field-text
              id="sysLogPrefix"
              v-model="itemData.config.sysLogPrefix"
              :label="$t('proxy_rtsp_server.sys_log_prefix')"
            />
          </b-col>
          <b-col cols="12" lg="6">
            <form-field-text
              id="readTimeout"
              v-model="itemData.config.readTimeout"
              :label="$t('proxy_rtsp_server.read_timeout')"
            />
          </b-col>
          <b-col cols="12" lg="6">
            <form-field-text
              id="writeTimeout"
              v-model="itemData.config.writeTimeout"
              :label="$t('proxy_rtsp_server.write_timeout')"
            />
          </b-col>
          <b-col cols="12" lg="6">
            <form-field-text
              id="writeQueueSize"
              v-model="itemData.config.writeQueueSize"
              :label="$t('proxy_rtsp_server.write_queue_size')"
              type="number"
            />
          </b-col>
          <b-col cols="12" lg="6">
            <form-field-text
              id="udpMaxPayloadSize"
              v-model="itemData.config.udpMaxPayloadSize"
              :label="$t('proxy_rtsp_server.udp_max_payload_size')"
              type="number"
            />
          </b-col>
          <b-col cols="12" lg="6">
            <form-field-text
              id="runOnConnect"
              v-model="itemData.config.runOnConnect"
              :label="$t('proxy_rtsp_server.run_on_connect')"
            />
          </b-col>
          <b-col cols="12" lg="6">
            <form-field-toggle
              id="runOnConnectRestart"
              v-model="itemData.config.runOnConnectRestart"
              :label="$t('proxy_rtsp_server.run_on_connect_restart')"
            />
          </b-col>
          <b-col cols="12" lg="6">
            <form-field-text
              id="runOnDisconnect"
              v-model="itemData.config.runOnDisconnect"
              :label="$t('proxy_rtsp_server.run_on_disconnect')"
            />
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
  </div>
</template>

<script>
import FormFieldText from "@/components/WizardModal/FormFields/FormFieldText.vue";
import FormFieldToggle from "@/components/WizardModal/FormFields/FormFieldToggle.vue";
import FormFieldSelect from "@/components/WizardModal/FormFields/FormFieldSelect.vue";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import useRtpsServerWizard from "./useRtpsServerWizard";
import { ref } from "@vue/composition-api";

export default {
  name: "LogsStep",
  components: {
    FormFieldText,
    FormFieldToggle,
    FormFieldSelect,
    ValidationObserver,
    ValidationProvider,
  },
  props: {
    propItemData: {
      type: Object,
      required: true,
    },
  },
  setup(props, context) {
    const configDefaults = {
      logLevel: "",
      logDestinations: [""],
      logFile: "",
      sysLogPrefix: "",
      readTimeout: "",
      writeTimeout: "",
      writeQueueSize: 0,
      udpMaxPayloadSize: 0,
      runOnConnect: "",
      runOnConnectRestart: false,
      runOnDisconnect: "",
    };

    const logLevelOptions = ref([
      { value: "info", text: "Info" },
      // { value: "debug", text: "Debug" },
      // { value: "warn", text: "Warning" },
      // { value: "error", text: "Error" },
    ]);

    const logDestinationsOptions = ref([
      { value: "stdout", text: "Standard Output" },
      // { value: "file", text: "File" },
      // { value: "syslog", text: "System Log" },
    ]);

    const { itemData, refFormObserver, getValidationState, validateStep } =
      useRtpsServerWizard(props, context, configDefaults);

    return {
      itemData,
      refFormObserver,
      getValidationState,
      validateStep,
      logLevelOptions,
      logDestinationsOptions,
    };
  },
};
</script>
